export default __webpack_public_path__ + "static/media/hombre-negocios-trabajando-tableta-cafe@2x.23f4a813.png";